<template>
  <div class="flex flex-col items-center justify-center scale-90 lg:px-5">
    <img :src="assetUrl('assets/img/escudogobe.png')" class="w-48" alt="instabug logo"/>
    <h1 class="heading--1 font-signautre">Tesoreria del Tolima</h1>
    <form class="w-full" @submit.prevent="submit">
      <div class="form__group">
        <label for="usuario" class="form__label">Usuario</label>
        <input
            type="text"
            :class="'form__input '+((!credentialsValid&&!form.usuario)?'notValid':'')"
            placeholder="Usuario"
            id="usuario"
            required
            v-model="form.usuario"
            autofocus
        />
      </div>
      <div class="form__group">
        <label for="password" class="form__label">Contraseña</label>
        <input
            type="password"
            :class="'form__input '+((!credentialsValid&&!form.password)?'notValid':'')"
            placeholder="Contraseña"
            id="password"
            required
            v-model="form.password"
        />
      </div>
      <button class="form__btn" type="submit">Ingresar</button>
      <router-link to="/recuperarContrasena">
        <button class="form__btn" type="button">¿Olvido su contraseña?</button>
      </router-link>
      
      <div class="errorLogin border-2 p-3 font-bold" v-if="!credentialsValid">
        <template v-if="typeof messageCredentialsInvalid === 'object'">
          <p class="errorLogin__text" v-for="(message, index) of messageCredentialsInvalid" :key="index">-
            {{ message }}</p>
        </template>
        <p class="errorLogin__text" v-else>- {{ messageCredentialsInvalid }}</p>
      </div>
    </form>
  </div>
</template>
<script>
import {useRouter} from "vue-router";
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import {assetUrl} from "@/common/constants";

export default {
  name: "loginForm",
  data() {
    return {};
  },
  methods: {
    assetUrl
  },
  setup() {
    const form = reactive({
      usuario: '',
      password: '',
    });
    let credentialsValid = ref(true);
    let messageCredentialsInvalid = ref('');
    const {loginUser} = useAuth();
    const router = useRouter();
    const submit = async () => {
      return await loginUser(form).then(resAuth => {
        if (resAuth.first_login) {
          router.push('/RecuperarContrasena_2/'+ resAuth.token);
        }
        else if (resAuth.ok && resAuth.requires2FA){ 
          router.push('/verificacion-2fa');
        }else if(resAuth.ok){
          router.push('/inicio');
        } else {
          credentialsValid.value = false;
          messageCredentialsInvalid.value = resAuth.message;
        }
      });
    }
    return {
      credentialsValid,
      messageCredentialsInvalid,
      form,
      submit
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/main.scss";

a:focus {
  outline: none;
}

.form {
  width: 100%;

  &__group {
    &:not(:last-child) {
      margin-bottom: 1.5rem;
    }
  }

  &__input {
    height: 2rem;
    width: 100%;
    padding: 2rem 1rem;
    border-radius: 4px;
    color: $color__primary;
    border: 1px solid $color__secondary;

    &:focus,
    &:active {
      outline: none;
    }

    &:placeholder-shown,
    &::placeholder {
      color: $color__secondary;
    }
  }

  &__label {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    color: $color__primary;
  }

  &__btn {
    width: 100%;
    @include customBorder($color__primary, $color__secondary);
    color: $color__white;
    padding: 1rem;
    border-radius: 4px;
    margin-bottom: 1rem;

    cursor: pointer;
  }
}

.errorLogin {
  @include customBorder(#fbe6e1, $color__gray--dark);

  &__text {
    color: $color__gray--dark;
  }
}

.notValid {
  border-color: $color__warning;
}
</style>
